import { inject } from '@angular/core';
import { CanActivateFn, UrlTree, createUrlTreeFromSnapshot } from '@angular/router';
import { Observable, Subscriber } from 'rxjs';
import { AuthenticationService } from '../authentication.service';
import { IAppState } from '../../../app/app.reducer';
import { Store } from '@ngrx/store';
import { selectNeedsReauthentication } from '../authentication.reducer';
import { logout } from '../authentication.actions';

export const authGuard: CanActivateFn = (route, state) => {
  const store$ = inject(Store<IAppState>);
  const service = inject(AuthenticationService);
  const logoutAndGoToLogin = (observer: Subscriber<boolean | UrlTree>) => {
    observer.next(createUrlTreeFromSnapshot(route, ['/login'])); // User is not logged in, redirect to login page
    store$.dispatch(logout());
    observer.complete();
  }

  return new Observable<boolean | UrlTree>((observer) => {
    store$.select(selectNeedsReauthentication).subscribe((needsReauthentication) => {
      if (needsReauthentication) {
        service.refreshToken().subscribe({
          next: (response) => {
            if (response) {
              observer.next(true); // User is logged in, allow navigation
              observer.complete();
            } else {
              logoutAndGoToLogin(observer);
            }
          },
          error: (error) => {
            logoutAndGoToLogin(observer);
          },
        });
      } else {
        observer.next(true);
        observer.complete();
      }
    });
  });
};
